import React, { useEffect } from "react";

const Maintenance = () => {
  useEffect(() => {
    document.body.style.setProperty("background", "#0f1a14", "important");
    document.body.style.setProperty("color", "#ffffff", "important");
    return () => {
      document.body.style.removeProperty("background");
      document.body.style.removeProperty("color");
    };
  }, []);

  return (
    <>
      <style>{`
        .maintenance-page {
          min-height: 100vh !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 24px !important;
          background: #0f1a14 !important;
          background-image: linear-gradient(160deg, #0f1a14 0%, #1a2e24 45%, #0d1511 100%) !important;
          font-family: Georgia, "Times New Roman", serif !important;
          text-align: center !important;
          color: #ffffff !important;
        }
        .maintenance-page h1.maintenance-page__title {
          font-size: clamp(1.75rem, 4vw, 2.5rem) !important;
          font-weight: 700 !important;
          margin: 0 0 16px !important;
          color: #d4af37 !important;
          -webkit-text-fill-color: #d4af37 !important;
          background: none !important;
          background-image: none !important;
        }
        .maintenance-page p.maintenance-page__text {
          font-size: 1.1rem !important;
          line-height: 1.7 !important;
          margin: 0 0 28px !important;
          color: #ffffff !important;
          -webkit-text-fill-color: #ffffff !important;
          opacity: 1 !important;
          text-align: center !important;
          background: none !important;
        }
        .maintenance-page a.maintenance-page__btn {
          display: inline-block !important;
          padding: 12px 28px !important;
          background-color: #d4af37 !important;
          color: #0f1a14 !important;
          -webkit-text-fill-color: #0f1a14 !important;
          font-weight: 700 !important;
          text-decoration: none !important;
          border-radius: 4px !important;
          font-size: 1rem !important;
        }
        .maintenance-page a.maintenance-page__btn:hover {
          background-color: #e0c05a !important;
          color: #0f1a14 !important;
          -webkit-text-fill-color: #0f1a14 !important;
        }
      `}</style>
      <div className="maintenance-page">
        <div style={{ maxWidth: "520px" }}>
          <img
            src="assets/images/logo-white.svg"
            alt="ComTech Gold"
            style={{ width: "180px", marginBottom: "28px" }}
          />
          <h1 className="maintenance-page__title">Site Under Maintenance</h1>
          <p className="maintenance-page__text">
            We are currently performing scheduled maintenance. Please visit our
            new site for the latest updates.
          </p>
          <a
            className="maintenance-page__btn"
            href="https://cgold.ae/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Continue to cgold.ae
          </a>
        </div>
      </div>
    </>
  );
};

export default Maintenance;
